import React from "react";

import "../styles/PageShell.css";
import { LeftSideBar } from "./LeftSideBar";
import { ToolBar } from "./Toolbar";

// Sidebar + navbar chrome for the pages that aren't the chart grid.
// Layout.js and the RNG page build the same chrome into their own grids
// because their content has to share columns with the sidebar.
export default function PageShell(props) {
  return (
    <div className="pageShell">
      <div className="pageShellSide">
        <LeftSideBar />
      </div>
      <div className="pageShellNav">
        <ToolBar />
      </div>
      <div className="pageShellContent">{props.children}</div>
    </div>
  );
}
